import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-grammar-without-internet',
  templateUrl: './grammar-without-internet.component.html',
  styleUrls: ['./grammar-without-internet.component.scss']
})
export class GrammarWithoutInternetComponent{

  @Input() windowsButton: boolean = false;
  @Input() sensitiveButton: boolean = false;
  @Input() modalButton: boolean = false;
  @Output() scrollToTarget = new EventEmitter<void>();

  constructor(
    public navigationService: NavigationService
  ) { }

  triggerScroll() {
    this.scrollToTarget.emit();
  }

}
